import dynamic from 'next/dynamic';

export default {
  ArticlePage: dynamic(() => import('./ArticlePage')),
  BasePage: dynamic(() => import('./BasePage')),
  HomePage: dynamic(() => import('./HomePage')),
  NotFoundPage: dynamic(() => import('./NotFoundPage')),
  PasswordProtectedPage: dynamic(() => import('./PasswordProtectedPage')),
  PureHtmlPage: dynamic(() => import('./PureHtmlPage')),
  EventPage: dynamic(() => import('./EventPage')),
  EventListPage: dynamic(() => import('./EventListPage/EventListPage')),
  EventSubmissionPage: dynamic(() => import('./EventSubmissionPage')),
  ContactPage: dynamic(() => import('./ContactPage')),
  LandingPage: dynamic(() => import('./LandingPage')),
  AboutUsPage: dynamic(() => import('./AboutUsPage')),
  RichTextPage: dynamic(() => import('./RichTextPage')),
  ForecastPage: dynamic(() => import('./ForecastPage')),
  SnippetPreview: dynamic(() => import('./SnippetPreview')),
  OrganizationPage: dynamic(() => import('./OrganizationPage')),
  ListPage: dynamic(() => import('./ListPage')),
  NewsListPage: dynamic(() => import('./NewsListPage')),
  NewsPage: dynamic(() => import('./NewsPage')),
};
